import React, { useState, useEffect } from 'react';
import {
    SealContainer,
    SealImage,
    SealText,
    SealWrapper,
    SealButton,
    LoadingText,
} from './identitySealStyles';
import { getRegeneraSeal } from '../../../../../coreApi';

const RegeneraSeal = ({
    sealText = 'Hey, thank you for signing up!\nHere is your identity NFT seal.',
}) => {
    const [sealImage, setSealImage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // useEffect(() => {
    //     const fetchSeal = async () => {
    //         try {
    //             const imageUrl = await getRegeneraSeal();
    //             setSealImage(imageUrl);
    //         } catch (error) {
    //             console.error('Error fetching Regenera Seal:', error);
    //             setError('Failed to load seal. Please try again.');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };
    //     fetchSeal();
    // }, []);
    useEffect(() => {
        const fetchFriendSeal = async () => {
            try {
                const sealData = await getRegeneraSeal();

                if (sealData.friend) {
                    const base64Image = sealData.friend;
                    setSealImage(base64Image);
                } else {
                    setError('No seal found for the "friend" role.');
                }
            } catch (error) {
                console.error('Error fetching Regenera Seal for friend:', error);
                setError('Failed to load seal. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchFriendSeal();
    }, []);

    const handleRedirect = () => {
        window.open(
            'https://blockscout.openprotestnet.lac-net.net/address/0x2A5612c212D75EEbc65aa197BDA6Fb4d97568E93',
            '_blank'
        );
    };
    if (!sealImage) return null;

    return (
        <SealContainer>
            {loading ? (
                <LoadingText>Loading your Regenera Seal...</LoadingText>
            ) : error ? (
                <SealText>{error}</SealText>
            ) : (
                <>
                    <SealWrapper>
                        {/* <SealImage src={sealImage} alt="Regenera Seal" /> */}
                        {sealImage && <SealImage src={sealImage} alt="Regenera Seal" />}
                        <SealText>
                            {sealText.split('\n').map((line, index) => (
                                <React.Fragment key={index}>
                                    {line}
                                    <br />
                                </React.Fragment>
                            ))}
                        </SealText>
                    </SealWrapper>
                    <SealButton onClick={handleRedirect}>View Details</SealButton>
                </>
            )}
        </SealContainer>
    );
};

export default RegeneraSeal;
